/**
 * Created by brunopoeta on 19/02/18.
 */

import EventsController from './controllers/events.controller';

export default function RouteConfig($stateProvider,
                                    $locationProvider,
                                    $urlRouterProvider) {

    $stateProvider
        .state('events', {
            url: '/{campus}',
            controller: EventsController,
            controllerAs: 'ctrl',
            params: {
                campus: { squash: false, value: null }
            }
        });

    $locationProvider.hashPrefix('');

    $urlRouterProvider.otherwise('/');

}
